import { FolderStateType } from '@redact/state/modules/casemedia/store';
import { CaseId } from '@common-modules/universal/models/Brands';

export function checkIsCaseId(
  folder: FolderStateType
): folder is FolderStateType<CaseId> {
  // A case folder will have a caseFiles property even if there are no case files
  if ('caseFiles' in folder) {
    return true;
  }
  return false;
}
